<template>
  <div class="library-topics-component">
    <topic :topic="asset" />
  </div>
</template>

<script>
import Topic from '@components/topics/topic';

import LibraryMixin from '@/mixins/library';

export default {
  components: { Topic },
  mixins: [LibraryMixin],
  props: {
    asset: {
      type: Object,
    },
  },
  computed: {
    assetId() {
      return this.$route.params?.assetId;
    },
  },
  mounted() {
    this.$store.dispatch('topics/load', { ids: [this.assetId], includeTags: true });
  },
};
</script>
